'use strict';

function getFacets(csrf) {
  let url = '/browse/search/facets';
  if(!window.location || !window.location.search || window.location.search.length === 0) {
    url += `?_csrf=${csrf}`;
  } else {
    url += window.location.search + `&_csrf=${csrf}`;
  }
  return fetch(`${url}`, { credentials: 'same-origin' })
    .then(res => {
      if(res.status > 200) {
        return Promise.reject(res);
      } else {
        return Promise.resolve(res);
      }
    })
    .then(res => res.json());
}

module.exports = {
  getFacets
}
